var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Colombia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#3f51b5",
    d: "M43.95,25H4.05c0.183,3.683,1.343,7.105,3.255,10h33.39C42.606,32.105,43.767,28.683,43.95,25z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffc107",
    d: "M44,24c0-11.046-8.954-20-20-20S4,12.954,4,24c0,0.338,0.034,0.667,0.05,1H43.95 C43.966,24.667,44,24.338,44,24z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff3d00",
    d: "M40.695,35H7.305c3.578,5.419,9.715,9,16.695,9S37.117,40.419,40.695,35z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Colombia);
export default __webpack_public_path__ + "static/media/icons8-colombia.f4c68e5e989b88df82d66eb405326fad.svg";
export { ForwardRef as ReactComponent };